//#region src/AppLayoutVariant.ts
var e = /* @__PURE__ */ function(e) {
	return e.TopNavigation = "top-navigation", e.SideNavigation = "side-navigation", e.ListingView = "listing-view", e.ChatView = "chat-view", e.SearchNavigation = "search-navigation", e.PinnedSearch = "pinned-search", e.FormView = "form-view", e;
}({});
//#endregion
export { e as AppLayoutVariant };
